export default "__VITE_ASSET__0b11deae__"